<template>
  <div class="product-multi-container">
    <button @click="$modal.show('productMultipleImageUploadModal')" style="margin-left:12px;width: 140px" class="button text-primary">{{ title }}</button>

    <modal name="productMultipleImageUploadModal" :adaptive="true" :width="600" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <admin-box-item title="상품 이미지 일괄 등록"
                        :useTab="false">
          <div class="columns is-multiline">
            <div class="column is-full" style="height: 200px">
              <input type="file" accept="image/*" @change="onFileChange" multiple/>
            </div>

            <div class="btn-group-justify-end">
              <button class="button is-light" @click="$modal.hide('productMultipleImageUploadModal')">취소</button>
              <button class="button is-primary" @click="clickUpload">확인</button>
            </div>
          </div>
        </admin-box-item>
      </div>
    </modal>

    <modal name="resultImageProgress" :click-to-close="false">
      <div class="lp-modal-wrapper result-download-progess-wrapper" v-if="resultImageProgress">
        <div style="margin-bottom:20px">{{ title }}</div>
        성공: {{ resultImageProgress.success }}<br>
        실패: {{ resultImageProgress.fail }}
        <div v-if="resultImageProgress.fail_res.length>0">
          <div>실패한 파일</div>
          <div class="fail-files-wrapper">
            <div v-for="(file, file_idx) in resultImageProgress.fail_res"
                 :key="`fail-file-${file_idx}`">{{ file }}</div>
          </div>
        </div>
        <button class="button is-primary close-button"
                @click="$modal.hide('resultImageProgress')"
                v-if="showCancelButton">닫기</button>
      </div>
    </modal>
  </div>
</template>
<script>
  export default {
    name: "ProductMultipleImageUpload",
    created() {
    },
    data() {
      return {
        title: '상품 이미지 일괄 등록',
        uploadFile: [],
        resultImageProgress: {success:0, fail:0, fail_res:['1234.png', '123123.png']},
        showCancelButton: false
      }
    },
    methods: {
      onFileChange(e) {
        this.uploadFile = e.target.files;
      },
      clickUpload() {
        this.showCancelButton = false;
        this.resultImageProgress = {success:0, fail:0, fail_res:[]}
        let config = {
          onDownloadProgress: res => {
            let result = "[" + res.target.response.slice(0,-1) + "]";
            result = JSON.parse(result).slice(-1)[0];
            this.resultImageProgress = result;
          }
        };

        if(this.uploadFile.length===0) {
          this.toast('파일을 첨부해주세요.');
          return;
        }
        let formData = new FormData;
        for (let item of this.uploadFile) {
          formData.append('files', item);
        }
        // formData.append('files', this.uploadFile)

        this.$modal.hide('productMultipleImageUploadModal');
        this.$modal.show('resultImageProgress');

        this.$axios.post('admin/product/image/upload', formData, config, {
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        }).then(res=> {
          this.showCancelButton = true;
          this.toast('파일 업로드 되었습니다.');
          // this.$modal.hide('resultImageProgress');
        }).catch(error => {
          this.toast('서버에 오류가 있습니다.');
          this.$modal.hide('resultImageProgress');
        });
      }
    }
  }
</script>
<style lang="stylus" scoped>
  .result-download-progess-wrapper
    height 100%
    font-size 15px
    .close-button
      position absolute
      right 20px
      bottom 20px

  .fail-files-wrapper
    height 110px
    overflow-y scroll
    border 1px solid rgb(206 206 206)
    margin-top 4px
    padding 4px
</style>
